
export interface WithIdInterface {
  id: string
}

export interface ResponseInerface extends WithIdInterface {
  title: string,
  description?: string,
  numeric_value: number,
  collection_id: string,
  question_id: string,
  vote?: {
    user_vote: boolean
  }
}

export interface FactorInterface extends WithIdInterface {
  title: string,
  question_type: string,
  weight?: number,
  is_draft?: boolean,
  description?: string,
  custom_attr_1?: string,
  custom_attr_2?: string,
  sort_order?: number,
  responses: ResponseInerface[]
}

export enum FactorsSource {
  CURRENT = "current",
  TEMPLATE = "template"
}